import api from "./api";

/* ===============================
   Dashboard Summary
================================ */
export const getDashboardSummary = async () => {
  const res = await api.get("/dashboard/project-summary");
  return res.data;
};

/* ===============================
   ✅ NEW: Productivity Trend API
   Used for dashboard charts
================================ */
export const getProductivityTrend = async () => {
  const res = await api.get("/dashboard/productivity-trend");
  return res.data;
};